/* GENERATED FROM reportmanager.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import {
  APIRequest,
  APIResponse,
  makeRequest,
  preProcessingResponse
} from '../'
import * as base from './base.service'

export class ReportManager {
  static CreateReport = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<CreateReportReq, {}, CreateReportResp>): Promise<
    APIResponse<CreateReportResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/reports`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<CreateReportResp>>()
          .then<APIResponse<CreateReportResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ListReport = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<ListReportReq, {}, ListReportResp>): Promise<
    APIResponse<ListReportResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/reports`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ListReportResp>>()
          .then<APIResponse<ListReportResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UpdateReport = ({
    params,
    queryVars,
    options,
    makeRequestOptions
  }: APIRequest<
    UpdateReportReq,
    { report_id: string },
    UpdateReportResp
  >): Promise<APIResponse<UpdateReportResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/reports/${queryVars.report_id}`,
      method: 'PATCH',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UpdateReportResp>>()
          .then<APIResponse<UpdateReportResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static DeleteReport = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<DeleteReportReq, {}, DeleteReportResp>): Promise<
    APIResponse<DeleteReportResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/reports`,
      method: 'DELETE',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<DeleteReportResp>>()
          .then<APIResponse<DeleteReportResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
}

export interface CreateReportReq {
  req_hdr?: base.ReqHdr
  report_type?: ReportTypeEnum
  client_time?: string
  account_id?: string
  filtered_items?: string[]
}

export interface CreateReportResp {
  resp_hdr?: base.RespHdr
}

export interface ListReportReq {
  req_hdr?: base.ReqHdr
  filter?: string
  sort_by?: string
  order_by?: base.OrderByEnum
  limit?: string
  offset?: string
  count?: boolean
}

export interface ReportDetail {
  id?: string
  name?: string
  description?: string
  created?: string
  owner?: string
  type?: ReportTypeEnum
  num_rows?: number
  status?: string
  status_id?: ReportStatusEnum
  accessed?: string
  status_reason?: string
}

export interface ListReportResp {
  resp_hdr?: base.RespHdr
  entries?: ReportDetail[]
  count?: number
}

export interface UpdateReportReq {
  req_hdr?: base.ReqHdr
  report_id?: string
  name?: string
  description?: string
}

export interface UpdateReportResp {
  resp_hdr?: base.RespHdr
}

export interface DeleteReportReq {
  req_hdr?: base.ReqHdr
  report_ids?: string[]
}

export interface DeleteReportResp {
  resp_hdr?: base.RespHdr
}

export interface DownloadReportReq {
  req_hdr?: base.ReqHdr
  report_ids?: string[]
}

export enum ReportTypeEnum {
  REPORT_TYPE_UNKNOWN = 'REPORT_TYPE_UNKNOWN',
  REPORT_TYPE_UNUSED_ACCESS_ROLE_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_ROLE_SUMMARY',
  REPORT_TYPE_UNUSED_ACCESS_ROLE_BY_SERVICE_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_ROLE_BY_SERVICE_SUMMARY',
  REPORT_TYPE_UNUSED_ACCESS_ROLE_BY_PRIVILEGE_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_ROLE_BY_PRIVILEGE_SUMMARY',
  REPORT_TYPE_UNUSED_ACCESS_IDENTITY_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_IDENTITY_SUMMARY',
  REPORT_TYPE_UNUSED_ACCESS_IDENTITY_BY_SERVICE_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_IDENTITY_BY_SERVICE_SUMMARY',
  REPORT_TYPE_UNUSED_ACCESS_IDENTITY_BY_PRIVILEGE_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_IDENTITY_BY_PRIVILEGE_SUMMARY',
  REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_SUMMARY',
  REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_BY_SERVICE_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_BY_SERVICE_SUMMARY',
  REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_BY_PRIVILEGE_SUMMARY = 'REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_BY_PRIVILEGE_SUMMARY'
}

export enum ReportStatusEnum {
  REPORT_STATUS_UNKNOWN = 'REPORT_STATUS_UNKNOWN',
  REPORT_STATUS_INITIATED = 'REPORT_STATUS_INITIATED',
  REPORT_STATUS_IN_PROGRESS = 'REPORT_STATUS_IN_PROGRESS',
  REPORT_STATUS_COMPLETED = 'REPORT_STATUS_COMPLETED',
  REPORT_STATUS_ERROR = 'REPORT_STATUS_ERROR',
  REPORT_STATUS_EXPIRING = 'REPORT_STATUS_EXPIRING'
}
